import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

// Actions
import { alerts } from 'modules/alerts/actions';

// Services
import Call from 'services/data/call';
import Person from 'services/data/person';
import PhoneNumber from 'services/data/phone-number';

// Components
import SVG from 'components/widgets/icons/svg';


export default class AnswerOption extends React.Component {
  static propTypes = {
    call: PropTypes.object.isRequired
  }

  constructor() {
    super();
    this.answer = this.answer.bind(this);
  }

  answer() {
    Call.answer(this.props.call.id)
      .catch(alerts.catchError);
  }

  render() {
    const { callStatus, userOnCall, lastUserOnCall, transferringTo } = this.props.call;
    const callIsAnswerable = _.isEmpty(userOnCall) && (callStatus === 'Incoming' || callStatus === 'Failed Transfer');
    
    return (
      <li
        onClick={callIsAnswerable ? this.answer : _.noop}
        className={classNames('triage-option-answer', 'triage-option-header', { 'triage-action-complete': !callIsAnswerable })}
      >
        <SVG src="svg/answer.svg" className="triage-option-icon answer" />
        
        {/* If the call is incoming */}
        { callStatus === 'Incoming' &&
          'Answer'
        }
        {/* If the call is transferring */}
        { callStatus === 'Transferring' &&
          `Transferring Call to: ${Person.fullName(transferringTo)}`
        }
        {/* If the call failed to transfer */}
        { callStatus === 'Failed Transfer' &&
          <span>
            Answer Call
            <div className="triage-option-additional-info">
              { _.isEmpty(lastUserOnCall) ?
                'Answer by ' :
                `Transfer from ${Person.fullName(lastUserOnCall)} to `
              }
              {Person.fullName(transferringTo)} failed
            </div>
          </span>
        }
        {/* If the call is active, show the name of the person currently on the call */}
        { callStatus === 'Active' &&
          `Currently on Call: ${Person.fullName(userOnCall)}`
        }
        {/* If the call is not currently ongoing, offer the opportunity to call back */}
        { !_.includes(['Incoming', 'Active', 'Transferring', 'Failed Transfer'], callStatus) &&
          <span>
            <span>Call back at: </span>
            <a href={`tel:${this.props.call.from}`}>{PhoneNumber.format(this.props.call.from)}</a>
          </span>
        }
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/models/triage/triage-items/triage-options/answer.js